import { BalanceStatus } from '../../../models/ops/vtpass.model';
import { useGet } from '../../useApi';

// GET /admin/vtpass/balance-status (ops spec V6).
const useVtpassBalanceStatus = () => {
  const { data, loading, fetch } = useGet<BalanceStatus>('Failed to load the VTpass balance');
  return { status: data, loading, fetchStatus: () => fetch('api/v1/admin/vtpass/balance-status') };
};

export default useVtpassBalanceStatus;
